import { generateTestId } from "@client-shared";
import { format } from "date-fns";
import type { ChangeEvent } from "react";

export const setSingleVariantFormTestId = (identifier: string, index?: number): string =>
  generateTestId("SingleVariantForm", identifier, index);

/**
 * Returns a numeric `<input>` change handler that parses the raw value into a
 * number (or null when empty) before delegating to a react-hook-form field's
 * `onChange`. Shared by the cross-border and single-region price inputs so the
 * parse logic lives in one place.
 */
export const handleNumericFieldChange =
  (onChange: (value: number | null) => void) =>
  (event: ChangeEvent<HTMLInputElement>): void =>
    onChange(event.target.value ? Number.parseFloat(event.target.value) : null);

/** Serialises a picked date to the form's `yyyy-MM-dd` string; a cleared date becomes an empty string. */
export const toDateFieldValue = (date: Date | undefined): string => (date ? format(date, "yyyy-MM-dd") : "");
